import React from "react";
import { useRouteError } from "react-router-dom";

// Define el tipo para el error
interface RouteError {
  statusText?: string;
  message?: string;
}

export default function ErrorPage() {
  // Especifica el tipo del error como 'any' o un tipo personalizado si tienes más información del error
  const error = useRouteError() as RouteError;

  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error?.statusText || error?.message}</i>
      </p>
    </div>
  );
}
